import { lazyLoad } from 'utils/loadable';

export const QuestionListPage = lazyLoad(
  () => import('./index'),
  module => module.QuestionListPage,
);
